import Typography from '@mui/material/Typography'

export default function EmptyMessage({children, ...props}){
  return <Typography
    variant="body2"
    {...props}
    sx={{fontStyle: 'italic', ...props.sx}}
  >{children}</Typography>
}
